import React from "react";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect
} from "react-router-dom";

// Pages
import { StartPage } from "./pages/StartPage";
import { Services } from "./pages/Services";
import { SignUpForm } from "./pages/SignUpForm";
import { GDPR } from "./pages/GDPR";
import { FAQ } from "./pages/FAQ";
import { NotFound } from "./pages/NotFound";
import { RealityCheck } from "./pages/RealityCheck";
import { ActionPlan } from "./pages/ActionPlan";
import { Recruitment } from "./pages/Recruitment";
import { Lectures } from "./pages/Lectures";
import { Workshops } from "./pages/Workshops";
import { Ads } from "./pages/Ads";
import { Equality } from "./pages/Equality";
import { Leadership } from "./pages/Leadership";
// import { CompanyForm } from "./pages/CompanyForm";
// import { ContactForm } from "./pages/ContactForm";

// Components
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";

// Styling
import { PageWrapper } from "./styling/GlobalStyling";


// APP --------------------------------------
export const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Switch>
        <PageWrapper>
          <Route component={StartPage} path="/" exact />
          <Route component={SignUpForm} path="/for-queens" />
          <Route component={Services} path="/vara-tjanster" />
          {/* <Route component={ContactForm} path="/kontakt" /> */}
          <Route component={FAQ} path="/faq" />
          <Route component={ActionPlan} path="/action-plan" />
          <Route component={RealityCheck} path="/reality-check" />
          <Route component={Recruitment} path="/rekrytering" />
          <Route component={Lectures} path="/forelasningar" />
          <Route component={Workshops} path="/workshops" />
          <Route component={Ads} path="/skapa-annonser" />
          <Route component={Equality} path="/jamstalldhetspolicy" />
          <Route component={Leadership} path="/ledarskap" />
          {/* <Route component={CompanyForm} path="/for-foretag" /> */}
          <Route component={GDPR} path="/gdpr" />
          <Route component={NotFound} path="/404" />
        </PageWrapper>
        <Redirect to="/404" />
      </Switch>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
